import { render, staticRenderFns } from "./ExamCard.vue?vue&type=template&id=a9c51034"
import script from "./ExamCard.vue?vue&type=script&lang=js"
export * from "./ExamCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports